module.exports = __webpack_public_path__ + "img/ValidationReport_6.1a2a5e87.jpg";